import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import deleteFolderOperation from 'owa-service/lib/operation/deleteFolderOperation';
import folderId from 'owa-service/lib/factory/folderId';
import deleteFolderRequest from 'owa-service/lib/factory/deleteFolderRequest';
export default function deleteFolderService(deleteFolderId, permanentlyDelete) {
    return deleteFolderOperation({
        Header: getJsonRequestHeader(),
        Body: deleteFolderRequest({
            DeleteType: permanentlyDelete ? 'SoftDelete' : 'MoveToDeletedItems',
            FolderIds: [folderId({ Id: deleteFolderId })],
        }),
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=deleteFolderService.js.map